import ComponentPopperService from './component-popper';
import Dialog from './Dialog.vue';

import { getStore } from '@/utils/storeAccess';

type DefaultOptions = {
  cancelOnClickOutside: boolean;
  cancelOnEscape: boolean;
  closeOnCTAClick?: boolean;
  userIdsHideNotification: Array<string>; // add ids of users for whom want to hide dialog
  on: Record<string, (reason?: unknown) => unknown>;
  role?: 'dialog' | 'alertdialog' | 'none';
  ariaLabel?: string;
  ariaLabelledby?: string;
  ariaDescribedby?: string;
  restoreFocusTo?: HTMLElement;
};

export type DialogAccessibilityOptions = Pick<
  DefaultOptions,
  'role' | 'ariaLabel' | 'ariaLabelledby' | 'ariaDescribedby' | 'restoreFocusTo'
>;

const defaultOptions: DefaultOptions = {
  cancelOnClickOutside: true,
  cancelOnEscape: true,
  closeOnCTAClick: true,
  userIdsHideNotification: [
    '51c794bb-ab8b-4f47-960f-bde37b02e6ae',
    'd4578df7-0844-4a0f-aab1-b67f8621d76b',
    '2a4da913-d2a0-4558-a788-244ee1a84a2c'
  ],
  role: 'dialog',
  on: {}
};

function show(component: any, props?: any, options?: any) {
  const user = getStore()?.state.user.currentEventUser;
  if (defaultOptions.userIdsHideNotification.includes(user?.id || '')) {
    return { promise: Promise.resolve(), index: null };
  }

  return ComponentPopperService.show(Dialog, { component, props }, { ...defaultOptions, ...options });
}

function close(index: any) {
  return ComponentPopperService.close(index);
}

export default {
  show,
  close
};
